"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Variant = exports.Size = exports.Color = exports.Button = void 0;
var _react = _interopRequireWildcard(require("react"));
var _button = require("@react-aria/button");
var _classnames = _interopRequireDefault(require("classnames"));
var _LoadingIndicator = require("../LoadingIndicator");
require("focus-visible");
require("./Button.css");
var _excluded = ["children", "className", "isLoading", "isDisabled", "isSubmit", "variant", "color", "size", "startEnhancer", "endEnhancer"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var Size = exports.Size = /*#__PURE__*/function (Size) {
  Size["Small"] = "small";
  Size["Large"] = "large";
  return Size;
}({});
var Variant = exports.Variant = /*#__PURE__*/function (Variant) {
  Variant["Primary"] = "primary";
  Variant["Secondary"] = "secondary";
  return Variant;
}({});
var Color = exports.Color = /*#__PURE__*/function (Color) {
  Color["Highlight"] = "highlight";
  Color["Red"] = "red";
  Color["Greyscale"] = "greyscale";
  return Color;
}({});
var Button = _ref => {
  var children = _ref.children,
    className = _ref.className,
    isLoading = _ref.isLoading,
    isDisabled = _ref.isDisabled,
    isSubmit = _ref.isSubmit,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? Variant.Primary : _ref$variant,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? Color.Highlight : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? Size.Small : _ref$size,
    startEnhancer = _ref.startEnhancer,
    endEnhancer = _ref.endEnhancer,
    rest = _objectWithoutProperties(_ref, _excluded);
  var ref = (0, _react.useRef)(null);
  var _useButton = (0, _button.useButton)(_objectSpread(_objectSpread({}, rest), {}, {
      type: isSubmit ? 'submit' : 'button',
      isDisabled: isDisabled || isLoading
    }), ref !== null && ref !== void 0 ? ref : null),
    buttonProps = _useButton.buttonProps,
    isPressed = _useButton.isPressed;
  var buttonClasses = (0, _classnames.default)(className, 'zui-button', "zui-button-".concat(size), "zui-button-".concat(variant), "zui-button-".concat(color), {
    'zui-button-active': isPressed,
    'zui-button-loading': isLoading,
    'zui-button-disabled': isDisabled
  });
  return /*#__PURE__*/(0, _react.createElement)('button', _objectSpread({
    className: buttonClasses,
    ref,
    'aria-busy': isLoading,
    'aria-disabled': isDisabled
  }, buttonProps), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "zui-button-content-container"
  }, !isLoading && startEnhancer, /*#__PURE__*/_react.default.createElement("div", {
    className: "zui-button-content-".concat(size)
  }, isLoading ? /*#__PURE__*/_react.default.createElement(_LoadingIndicator.Spinner, {
    className: "zui-button-spinner"
  }) : children), !isLoading && endEnhancer)));
};
exports.Button = Button;
//# sourceMappingURL=Button.js.map